export const englishLocalisation = {
  invalidInput: 'Card information is invalid or empty',
  klarnaNotSupported: "Klarna can't be added here. Please go back and choose Klarna",
  networkIssue: 'Unable to contact {brand} at this time, check your network and try again',
  unknownIssue: 'Something went wrong',
  cardRefused: 'Card refused by your bank',
  payButton: 'Next',
  checkoutTitle: 'Pay',
  checkoutCancel: 'Cancel',
  checkoutHeader: '{amount} to {merchant}',
  checkoutPay: 'Pay',
  closeButton: 'Close',
  poweredBy: 'Powered by',
  tryAgain: 'Try Again',
  unexpectedAuthorisation:
    'The bank does not support authorisation of the card. Please contact customer service.',
  'creditCard.numberField.title': 'Card number',
  'creditCard.numberField.placeholder': 'Card number',
  'creditCard.numberField.invalid': 'Invalid card number',
  'creditCard.expiryDateField.title': 'Expiry date',
  'creditCard.expiryDateField.placeholder': 'MM/YY',
  'creditCard.expiryDateField.invalid': 'Invalid expiry date',
  'creditCard.expiryDateField.month': 'Month',
  'creditCard.expiryDateField.month.placeholder': 'MM',
  'creditCard.expiryDateField.year.placeholder': 'YY',
  'creditCard.expiryDateField.year': 'Year',
  'creditCard.cvcField.title': 'CVC / CVV',
  'creditCard.cvcField.placeholder': '123',
  'creditCard.oneClickVerification.invalidInput.title': 'Invalid CVC / CVV',
  'creditCard.cvcField.placeholder.3digits': '3 digits',
  'error.title': 'Something went wrong',
  'error.subtitle.redirect': 'Something went wrong',
  'error.subtitle.payment': 'Payment failed',
  'error.subtitle.refused': 'Payment failed',
  'error.message.unknown': 'Something went wrong',
  'error.va.gen.01': 'This field is required',
  'error.va.gen.02': "There's something wrong here",
  'error.va.sf-cc-num.01': 'Invalid card number',
  'error.va.sf-cc-num.02': "This card number doesn't match the card type",
  'error.va.sf-cc-num.03': 'This card is not supported',
  'error.va.sf-cc-dat.01': 'Card is too old',
  'error.va.sf-cc-dat.02': 'Date is too far in the future',
  'fscp.error.payment-failed': 'Payment failed',
  'fscp.error.timeout': "Time's up",
  'fscp.error.message.timeout': 'The payment remained inactive for too long. Please try again.',
  'fscp.error.unknown': 'Something went wrong',
  'fscp.error.message.insufficientFunds':
    'There is not enough money on the card. Please try a different card.',
  'fscp.error.message.invalidCard': 'Your card was declined.',
  'creditCard.encryptedCardNumber.aria.iframeTitle': 'Card number',
  'creditCard.encryptedCardNumber.aria.label': 'Card number',
  'creditCard.encryptedExpiryDate.aria.iframeTitle': 'Expiry date',
  'creditCard.encryptedExpiryDate.aria.label': 'Expiry date',
  'creditCard.encryptedExpiryMonth.aria.iframeTitle': 'Expiry month',
  'creditCard.encryptedExpiryMonth.aria.label': 'Expiry month',
  'creditCard.encryptedExpiryYear.aria.iframeTitle': 'Expiry year',
  'creditCard.encryptedExpiryYear.aria.label': 'Expiry year',
  'creditCard.encryptedSecurityCode.aria.iframeTitle': 'Security code',
  'creditCard.encryptedSecurityCode.aria.label': 'Security code',
  abortFailed: 'Unable to cancel payment.',
};

export type TextLocalisation = typeof englishLocalisation;
